import { IndividualIdentityForm } from './IndividualIdentityForm';

type Props = unknown;

export function OnboardingIndividualIdentityView(): JSX.Element {
  return <IndividualIdentityForm />;
}

export type OnboardingIndividualIdentityViewProps = Props;
